
<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
          <v-row class="d-flex justify-center mt-3">
              <v-col cols="4">
                  <v-text-field
                  label="Perfil"
                  v-model="form.filters.perfil"
                  outlined
                  dense
                  ></v-text-field>
              </v-col>
              <sca-select-ativo
                :cols="2"
                :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
                v-model="form.filters.situacao"
              ></sca-select-ativo>
              <sca-date-picker
              :cols="2"
              label="Data Início"
              v-model="form.filters.dataInicio"
              removeIcon
              outlined
              dense
            ></sca-date-picker>
            <sca-date-picker
            :cols="2"
              v-model="form.filters.dataFim"
              label="Data Final"
              removeIcon
              outlined
              dense
            ></sca-date-picker>
          </v-row>
           <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarRelatorios"
            ></sca-tooltip>
            <sca-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5 printable"
        :headers="headersAnalitico"
        :items="form.lists.listRelatorios"
        :items-per-page="10"
        :footer-props="$footerProps"
        show-expand
        sort-by="dataAcao"
        :sort-desc="true"
        :expanded.sync="expanded"
      >
        <template v-slot:[`item.perfil`]="{ item }">
          {{ item.perfil }}
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="grupos" :colspan="headers.length">
            <v-chip-group active-class="primary--text" column>
              <v-chip class="chip-permissao" v-for="(grupo, i) in item.grupos" :key="i">
                <v-icon class="grupo" small>
                  mdi-checkbox-marked-circle-outline
                </v-icon>
                {{ grupo.nomeExibicao }}
              </v-chip>
            </v-chip-group>
          </td>
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          <sca-label-ativo :ativo="item.situacao" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.dataAcao`]="{ item }">
          {{ $formatarDataHora(item.dataAcao) }}
        </template>
        <template v-slot:[`item.acao`]="{ item }">
          {{ item.acao }}
        </template>
      </v-data-table>
      <sca-buttons
        v-if="form.lists.listRelatorios.length"
        actionText="Baixar PDF"
        cancelText="Baixar CSV"
        @click="baixarRelatorioPdf"
        @cancel="baixarCSVRelatorio"
      ></sca-buttons>
    </v-container>
  </div>
</template>

<script>
  import pageLoadingMixin from "mixins/page-loading.mixin";
  import RelatorioDeLog from "services/relatorios-log/manter-perfil-log.service"
  export default {
      name: "RelatorioLogPerfil",
      mixins: [pageLoadingMixin, RelatorioDeLog],

      data: () => ({
      onReport: false,
      expanded: [],
      form: {
          filters: {
              perfil: null,
              situacao: null,
              dataInicio: null,
              dataFim: null,
          },
          lists: {
              listRelatorios: [],
          },
      },
      headersAnalitico: [
          { text: "Perfil", align: "center", value: "perfil" },
          { text: "Grupos", align: "center", value: "data-table-expand"},
          { text: "Situação", align: "center", value: "situacao" },
          { text: "Data/Hora da ação", align: "center", value: "dataAcao" },
          { text: "Ação", align: "center", value: "acao" },
      ],
      }),
      methods: {
      async buscarRelatorios() {
          const isValid = this.validarDatas();
          if (!isValid) return;
          if (!this.verificarFiltrosPreenchidos()) return;
          this.showPageLoading();
          try {
          const { data } = await this.$obterRelatorioLogPerfil({ params: this.form.filters });
          this.processarRespostaRelatorio(data);
          } finally {
          this.hidePageLoading();
          }
      },
      validarDatas() {
      const { dataInicio, dataFim } = this.form.filters;

      if (dataInicio && dataFim) {
        if (new Date(dataFim) < new Date(dataInicio)) {
          this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
          return false;
        }
        if (new Date(dataInicio) > new Date(dataFim)) {
          this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
          return false;
        }
      }
      return true;
    },

    verificarFiltrosPreenchidos() {
      const { perfil, situacao, dataInicio, dataFim } = this.form.filters;
      if (!perfil && situacao == null && !dataInicio && !dataFim) {
        this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
        return false;
      }
      return true;
    },

      async baixarCSVRelatorio() {
        this.showPageLoading();
        try {
        const { data } = await this.$obterRelatorioLogCSVPerfil({ params: this.form.filters });
        this.$baixarRelatorioCSV(data, `SCA.RelatórioDeLogDePerfilCSV`);
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
        }
      },

      async baixarRelatorioPdf() {
        this.showPageLoading();
        try {
        const { data } = await this.$obterRelatorioLogPDFPerfil({ params: this.form.filters });
        const url = URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "SCA.RelatórioDeLogDePerfil.pdf");
        document.body.appendChild(link);
        link.click();
        this.$notifySuccess("Operação realizada com sucesso.");
        } finally {
        this.hidePageLoading();
        }
      },

      processarRespostaRelatorio(data) {
        this.form.lists.listRelatorios = data.lista;
      },

      resetForm() {
        this.form.filters.dataInicio = null;
        this.form.filters.dataFim = null;

        this.$nextTick(() => {
          this.$set(this.form.filters, 'dataInicio', null);
          this.$set(this.form.filters, 'dataFim', null);
        });
        this.form.filters.perfil = null;
        this.form.filters.situacao = null;

        this.form.lists.listRelatorios = [];
        this.expanded = [];
      }
    },
  };
</script>
<style scoped>
.permissoes {
padding: 1em !important;
text-align: center;
font-weight: 500;
}
.permissao {
padding-right: 0.5em;
}
</style>
